export default __webpack_public_path__ + "alberta-fab-print.beff316e4e62bfeccb13.svg";